import React, { useState } from "react";

export default function PasswordInput({
  id,
  name,
  autoComplete,
  value,
  onChange,
  disabled,
  required,
  minLength,
  showLabel,
  hideLabel,
}) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="onboarding-password-input-wrap">
      <input
        id={id}
        className="onboarding-input"
        type={isVisible ? "text" : "password"}
        name={name}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      <button
        className="onboarding-password-toggle"
        type="button"
        aria-label={isVisible ? hideLabel : showLabel}
        onClick={() => setIsVisible((visible) => !visible)}
        disabled={disabled}
      >
        <svg
          aria-hidden="true"
          focusable="false"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {isVisible ? (
            <>
              <path d="M3 3l18 18" />
              <path d="M10.6 10.6a2 2 0 002.8 2.8" />
              <path d="M9.9 5.2A10.8 10.8 0 0112 5c6.4 0 10 7 10 7a15.5 15.5 0 01-3.1 3.8" />
              <path d="M6.2 6.2C3.5 8 2 12 2 12s3.6 7 10 7c1.1 0 2.1-.2 3-.5" />
            </>
          ) : (
            <>
              <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" />
              <circle cx="12" cy="12" r="3" />
            </>
          )}
        </svg>
      </button>
    </div>
  );
}
